import request from "./request";
/**
 * 采集某日数据
 * @param year 年
 * @param month 月
 * @param day 日
 */
export default async function getBusinessByDate(params = {}) {
  return await request.get("/spin/dataBusiness/getBusinessByDate", {
    params,
  });
}
